import { c as _c } from "react/compiler-runtime";
import { numberWithCommas } from '@/shared/utils';
import { Switch, Tooltip } from '@ncai-axe/react-ui-v3';
import CreditIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_credit.svg';
import IcInformationFill from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_information_fill.svg';
import { cn } from '@ncai-axe/react-ui-v3/utils';
import styles from './styles.module.scss';
type Props = {
  label: string;
  tooltip?: string;
  checked: boolean;
  creditAmount: number;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  switchSize?: 'small' | 'medium';
};
export default function AISwitch(t0) {
  const $ = _c(24);
  const {
    label,
    checked,
    tooltip,
    creditAmount,
    onCheckedChange,
    className,
    switchSize: t1
  } = t0;
  const switchSize = t1 === undefined ? "small" : t1;
  let t2;
  if ($[0] !== onCheckedChange) {
    t2 = checked_0 => {
      onCheckedChange(checked_0);
    };
    $[0] = onCheckedChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleCheckedChange = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn(styles.aiSwitch, className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = <span>{label}</span>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== tooltip) {
    t5 = tooltip && <Tooltip className={styles.tooltip} content={tooltip}><div className={styles.tooltipIcon}><IcInformationFill className={styles.infoIcon} /></div></Tooltip>;
    $[6] = tooltip;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CreditIcon className={styles.creditIcon} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== creditAmount) {
    t7 = numberWithCommas(creditAmount);
    $[9] = creditAmount;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className={styles.credit}>{t6}<span className={styles.creditAmount}>{t7}</span></div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== checked || $[14] !== handleCheckedChange || $[15] !== switchSize) {
    t9 = <Switch checked={checked} size={switchSize} onCheckedChange={handleCheckedChange} />;
    $[13] = checked;
    $[14] = handleCheckedChange;
    $[15] = switchSize;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== switchSize || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className={t3} data-switch-size={switchSize}>{t4}{t5}{t8}{t9}</div>;
    $[17] = switchSize;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}